// extracted by mini-css-extract-plugin
module.exports = {"header":"PrizeInputSection_header__RAvIU","subheading":"PrizeInputSection_subheading__elMYR"};